import { render, staticRenderFns } from "./urlProduct.vue?vue&type=template&id=1c08793e&"
import script from "./urlProduct.vue?vue&type=script&lang=js&"
export * from "./urlProduct.vue?vue&type=script&lang=js&"
import style0 from "./urlProduct.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports